/* eslint-disable */
import React, { Fragment, Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import WarningIcon from "@material-ui/icons/Warning";
import { Button, Dialog, MenuItem, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { onboardingService } from '../../services/onboard.service';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import FullscreenLoader from '../../common/components/FullscreenLoader';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { getSpecialPrice, statusReopened } from "../../store/actions/specialprice.actions";
import _, { get } from "lodash";
import { useEffect } from "react";
import SpecialPrcieRequest from './SpecialPriceRequest';
// import { statusReopenedKam } from "../../store/actions/specialPriceKam.actions";
import { userAccesssRestriction } from "../../store/actions/specialprice.actions";

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    title: {
        flex: '1 1 100%',
    },
    closeButton: {
        backgroundColor: '#EAEAEA',
        width: 120,
        fontWeight: 800,
        textTransform: 'capitalize',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#666666',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
        marginRight: 24
    },
    icon: {
        float: "left",
        margin: "0 20px 20px 0",
        height: "100%",
        fill: "white",
    },
    cancel: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#919191',
        textTransform: 'capitalize'
    },
    kamText: {
        color: '#616161',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'inherit'
    },
    textFontColor: {
        color: 'red',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 900,
        textTransform: 'inherit'
    }
}));

export default function ReopnedStatusDialog(props: any) {
    const dispatch: Dispatch<any> = useDispatch();
    const classes = useStyles();
    const [loading, setLoading] = React.useState<boolean>(false);
    const history = useHistory()
    const { selectedNewDealer }: any = useSelector((state: any) => state.dealer);
    const b2bUserId = get(selectedNewDealer, "createdByB2bUserId", "");
    const [isValid, setIsValid] = React.useState<boolean>(true);
    const [successMessage, setSuccessMessage] = React.useState<any>(null);
    const { openRequestSnackbar, handleopenCloseSnackbar } = props;
    const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
    const [kamText, setkamText] = React.useState<any>("");
    const [kamTextErrorMessage, setkamTextErrorMessage] = React.useState<any>("");
    const [kamTextError, setkamTextError] = React.useState<boolean>(false);
    const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
    const sapCustomerId = get(profileDetails, 'data.data.basicInfo.sapCustomerId', "");
    const { viewSpecialPrice } = useSelector((state: any) => state.specialPrice)
    const webApplicationLoginId = sessionStorage.getItem('webApplicationLoginId');
    const userName = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo.firstName + " " + profileDetails.data.data.basicInfo.lastName) || "";
    const { specialPrice, specialPriceStatus, storeReopenedDetails } = useSelector((state: any) => state.specialPrice)

    // ONCHANGE OF TEXTAREA-AUTOSIZE 
    const handleCustomerChange = (e: any) => {
        setkamText(e.target.value);
        if (e.target.required) {
            if (e.target.value === "" || e.target.value.trim() === "") {
                setkamTextError(true);
            }
            else {
                setkamTextError(false);
            }
        }
    }

     // FOR POST API CALL FOR BACK BUTTON API RESTRICTION
     const backButtonUserRestriction = async () => {
        setLoading(true)
        const data = {
            "requestId": viewSpecialPrice && viewSpecialPrice.data && viewSpecialPrice.data.data && viewSpecialPrice.data.data.data && viewSpecialPrice.data.data.data.id,
        }
        let savedData: any = await dispatch(userAccesssRestriction(data));
        if (savedData && savedData.message && savedData.message.status === 'S') {
            // props.setSuccessMessage(savedData && savedData.message && savedData.message.message);
            // props.handleopenCloseSnackbar(true);
            setLoading(false)
        } else if (savedData && savedData.message && savedData.message.status === "E") {
            props.showErrorMessage(savedData && savedData.error);
            props.handleopenCloseErrorSnackbar(true);
            props.handleopenCloseSnackbar(false);
            setLoading(false)
        }
    }

    // FOR POST API CALL FOR FORWARD TO KAM
    const reopenedStatusData = async () => {
        setLoading(true)
        const data =
        {
            "sapCustomerId": props.sapId,
            "requestId": props.responseIDData,
            "reopenBy": webApplicationLoginId,
            "reopenByName": userName
        }
        let savedData: any = await dispatch(statusReopened(data));
        if (savedData && savedData.message && savedData.message.status === 'S') {
            props.setSuccessMessage(savedData && savedData.message && savedData.message.message);
            props.handleopenCloseSnackbar(true);
            props.setRemoveValidationPopup(true);
            backButtonUserRestriction();
            setTimeout(() => {
                props.handleopenClose(false);
                history.push('/specialpricerequest');
                setLoading(false)
                dispatch(getSpecialPrice('All', false, '', '', '', 0))
            }, 3000)
        } else if (savedData && savedData.message && savedData.message.status === "E") {
            props.showErrorMessage(savedData && savedData.error);
            props.handleopenCloseErrorSnackbar(true);
            setLoading(false)
            setTimeout(() => {
                props.handleopenClose(false);
            }, 2000)
        }
    }

    const successReopned = () => {
        reopenedStatusData();
    }

    return (
        <Fragment>
            {loading && <FullscreenLoader />}
            <Dialog
                open={props.open ? true : false}
                onClose={() => { props.handleopenClose(false); props.setOpenErrorSnackbar(false); props.setSuccessMessage(''); }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                {/* <Snackbar
                    open={props.openRequestSnackbar ? true : false}
                    type={props.openErrorSnackbar ? 'error' : ''}
                    handleopenClose={() => {  }} 
                    // message={props.successMessage}
                /> */}
                <DialogContent>
                    <div className={classes.root}>
                        <div className="col-12 mt-1 px-0 pr-0">
                            <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                                <h4 className="shift-to-party-page-title">
                                    <IconButton aria-label="close" className="float-right pr-3 mt-2" onClick={() => { props.handleopenClose(false); setkamTextErrorMessage(false); setkamTextError(false); setkamText(null); }}>
                                        <CloseIcon />
                                    </IconButton>
                                </h4>
                            </Typography>
                        </div>
                        <DialogContent>
                            <div className={classes.icon}>
                                <CheckCircleIcon className="forward-to-kam-right-arrow" fontSize="small" />
                            </div>
                            <div className='mt-3'>
                                <DialogContentText id="alert-dialog-description">
                                    <div className={`${classes.textFontColor}`}>
                                    </div>
                                    <div className={`mt-0${classes.kamText}`}>
                                        <h6 className="mb-0"> Are you sure you want to reopned this request ? </h6>
                                    </div>
                                </DialogContentText>
                            </div>
                        </DialogContent>
                    </div>
                    <div className="col-md-12 mt-2 px-5">
                        <div className="d-flex align-items-center">
                            <div className="col-md-">
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <div className="col-12 mt-2 mb-2">
                    <div className="d-flex align-items-center">
                        <div className="row-space-start ml-auto">
                            <DialogActions className="mt-3 mb-1 justify-content-end">
                            {/* <Button variant="contained"
                                    color="secondary" className="check-availability-button-access-tab"
                                    onClick={() => {
                                        props.ViewDetailsData();
                                    }}
                                >View Request Details
                                </Button> */}
                                <Button variant="contained"
                                    color="secondary" className="check-availability-button-access-tab"
                                    onClick={() => {
                                        successReopned();
                                    }}
                                >Yes
                                </Button>
                                <Button variant="contained" className={classes.closeButton}
                                    onClick={() => { props.handleopenClose(false); setkamTextErrorMessage(false); setkamTextError(false); setkamText(null); }}
                                >Cancel
                                </Button>
                            </DialogActions>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Fragment>
    );
}
